import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { usePostProductMutation } from "../../services/productApi";
import axios from "axios";

import {
  CircularProgress,
  Alert,
  Box,
  Grid,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  IconButton,
  Paper
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";

function NewProduct() {
  const navigate = useNavigate();
  const [server_error, setServerError] = useState({});
  const [success, setSuccess] = useState(false);
  const [postProduct, { isLoading }] = usePostProductMutation();
  const [categories, setCategories] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [brands, setBrands] = useState([]);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [types, setTypes] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [filteredVariations, setFilteredVariations] = useState([]);

  const [imge, setImge] = useState({
    image1: '', image2: '', image3: '', image4: '',
  });

  const [data, setData] = useState({
    product_Name: '',
    product_isSale: 'Yes',
    product_Price: '',
    product_Stock: '',
    product_Description: '',
    image1: '',
    image2: '',
    image3: '',
    image4: '',
    category_Name: '',
    SKU: '',
    implant_Company: '',
    brand_Name: '',
    variation_name: '',
    type_name: '',
  });

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [categoryRes, companyRes, brandRes, typeRes] = await Promise.all([
          axios.get("https://backend.hira-tech.co.uk/product/api/categories/"),
          axios.get("https://backend.hira-tech.co.uk/product/api/implant-companies/"),
          axios.get("https://backend.hira-tech.co.uk/product/api/brands/"),
          axios.get("https://backend.hira-tech.co.uk/product/api/type/")
        ]);

        setCategories(categoryRes.data);
        setCompanies(companyRes.data);
        setBrands(brandRes.data);
        setTypes(typeRes.data);

        // Initialize default values after data is loaded
        if (typeRes.data.length > 0) {
          const firstType = typeRes.data[0];
          setData(prev => ({
            ...prev,
            type_name: firstType.type_name,
          }));

          // Set categories based on selected type
          const categoriesForType = categoryRes.data.filter(cat =>
            cat.types?.some(t => t.type_name === firstType.type_name)
          );
          setFilteredCategories(categoriesForType);
          if (categoriesForType.length > 0) {
            setData(prev => ({
              ...prev,
              category_Name: categoriesForType[0].category_Name,
            }));

            // Set variations based on selected category
            const variationsForCategory = categoriesForType[0].var || [];
            setFilteredVariations(variationsForCategory);
            if (variationsForCategory.length > 0) {
              setData(prev => ({
                ...prev,
                variation_name: variationsForCategory[0].variation_name,
              }));
            }
          }
        }

        if (companyRes.data.length > 0) {
          setData(prev => ({
            ...prev,
            implant_Company: companyRes.data[0].company_name,
          }));
          // Filter brands based on default company
          const filteredBrands = brandRes.data.filter(
            brand => brand.implant_company?.company_name === companyRes.data[0].company_name
          );
          setFilteredBrands(filteredBrands);
          if (filteredBrands.length > 0) {
            setData(prev => ({
              ...prev,
              brand_Name: filteredBrands[0].brand_name,
            }));
          }
        }

      } catch (error) {
        console.error("Failed to fetch initial data", error);
      }
    };

    fetchInitialData();
  }, []);

  const handleTypeChange = (typeName) => {
    // Filter categories based on selected type
    const categoriesForType = categories.filter(cat =>
      cat.types?.some(t => t.type_name === typeName)
    );
    setFilteredCategories(categoriesForType);

    // Reset category and variation when type changes
    const newCategory = categoriesForType.length > 0 ? categoriesForType[0].category_Name : "";

    // Update variations based on the new category
    const selectedCategory = categoriesForType[0];
    const variationsForCategory = selectedCategory?.var || [];
    setFilteredVariations(variationsForCategory);
    const newVariation = variationsForCategory.length > 0 ? variationsForCategory[0].variation_name : "";

    setData(prev => ({
      ...prev,
      type_name: typeName,
      category_Name: newCategory,
      variation_name: newVariation
    }));
  };

  const handleCategoryChange = (categoryName) => {
    const selectedCategory = categories.find(cat => cat.category_Name === categoryName);

    if (selectedCategory) {
      // Update variations based on selected category
      const variationsForCategory = selectedCategory.var || [];
      setFilteredVariations(variationsForCategory);

      const newVariation = variationsForCategory.length > 0 ? variationsForCategory[0].variation_name : "";

      setData(prev => ({
        ...prev,
        category_Name: categoryName,
        variation_name: newVariation
      }));
    }
  };

  const handleChange = event => {
    const { name, value } = event.target;

    if (name === "implant_Company") {
      const filtered = brands.filter(
        brand => brand.implant_company?.company_name === value
      );
      setFilteredBrands(filtered);
      setData(prev => ({
        ...prev,
        [name]: value,
        brand_Name: filtered.length > 0 ? filtered[0].brand_name : ""
      }));
    }
    else if (name === "type_name") {
      handleTypeChange(value);
    }
    else if (name === "category_Name") {
      handleCategoryChange(value);
    }
    else {
      setData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleImage = event => {
    const { name, files } = event.target;
    const file = files[0];
    if (!file) return;

    setImge(prev => ({ ...prev, [name]: file }));
    const objectUrl = URL.createObjectURL(file);
    setData(prev => ({ ...prev, [name]: objectUrl }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    Object.entries(imge).forEach(([key, value]) => {
      if (value) formData.append(key, value);
    });

    Object.entries(data).forEach(([key, value]) => {
      if (key !== 'image1' && key !== 'image2' && key !== 'image3' && key !== 'image4') {
        formData.append(key, value);
      }
    });

    try {
      const res = await postProduct(formData);

      if (res.error) {
        if (typeof res.error.data.errors === 'undefined') {
          alert('A server/network error occurred. Looks like CORS might be the problem. Sorry about this - we will get it fixed shortly.');
        }
        setServerError(res.error.data.errors || {});
      }

      if (res.data) {
        setSuccess(true);
        setTimeout(() => navigate('/admin/products'), 3000);
      }
    } catch (err) {
      console.error('Error submitting form:', err);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 4 }} style={{color:'#004aad'}}>
        Add New Product
      </Typography>

      <Paper elevation={3} sx={{ p: 3 }}>
        <Grid container spacing={4}>
          {/* Image Upload Section */}
          <Grid item xs={12} md={4}>
            <Grid container spacing={2}>
              {[1, 2, 3, 4].map((num) => (
                <Grid item xs={6} md={12} key={num}>
                  <Box
                    sx={{
                      position: 'relative',
                      height: 200,
                      border: '2px dashed #ccc',
                      borderRadius: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden',
                      bgcolor: '#f5f5f5',
                    }}
                  >
                    {data[`image${num}`] ? (
                      <img
                        src={data[`image${num}`]}
                        alt={`Preview ${num}`}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    ) : (
                      <Typography color="textSecondary">
                        Image {num} Preview
                      </Typography>
                    )}
                    <IconButton
                      component="label"
                      sx={{
                        position: 'absolute',
                        bottom: 8,
                        right: 8,
                        bgcolor: 'background.paper',
                      }}
                    >
                      <CloudUpload />
                      <input
                        type="file"
                        name={`image${num}`}
                        onChange={handleImage}
                        hidden
                        accept="image/*"
                      />
                    </IconButton>
                  </Box>
                  {server_error[`image${num}`] && (
                    <Typography color="error" variant="caption">
                      {server_error[`image${num}`][0]}
                    </Typography>
                  )}
                </Grid>
              ))}
            </Grid>
          </Grid>

          {/* Product Preview Section */}
          <Grid item xs={12} md={4}>
            <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
              <Typography variant="h6" gutterBottom>
                Product Preview
              </Typography>
              <Typography variant="h5" sx={{ mb: 2 }}>
                {data.product_Name || 'Product Name'}
              </Typography>

              <Grid container spacing={1} sx={{ mb: 2 }}>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">Status:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>{data.product_isSale}</Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="subtitle2">Price:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>
                    £{Number(data.product_Price || 0).toLocaleString("en-GB", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="subtitle2">Stock:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>{data.product_Stock || '0'}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">Type:</Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography>{data.type_name}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">Category:</Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography>{data.category_Name}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">Variation:</Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography>{data.variation_name}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">Implant Company:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>{data.implant_Company}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">Implant Connection:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>{data.brand_Name}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">SKU:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>{data.SKU || 'N/A'}</Typography>
                </Grid>
              </Grid>

              <Typography variant="subtitle2" gutterBottom>
                Description:
              </Typography>
              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                {data.product_Description || 'No description provided'}
              </Typography>
            </Paper>
          </Grid>

          {/* Form Section */}
          <Grid item xs={12} md={4}>
            <Box component="form" onSubmit={handleSubmit} noValidate>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Product Name"
                    name="product_Name"
                    value={data.product_Name}
                    onChange={handleChange}
                    error={!!server_error.product_Name}
                    helperText={server_error.product_Name?.[0]}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Description"
                    name="product_Description"
                    value={data.product_Description}
                    onChange={handleChange}
                    multiline
                    rows={3}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="SKU"
                    name="SKU"
                    value={data.SKU}
                    onChange={handleChange}
                    error={!!server_error.SKU}
                    helperText={server_error.SKU?.[0]}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Price (£)"
                    name="product_Price"
                    type="number"
                    value={data.product_Price}
                    onChange={handleChange}
                    error={!!server_error.product_Price}
                    helperText={server_error.product_Price?.[0]}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Stock"
                    name="product_Stock"
                    type="number"
                    value={data.product_Stock}
                    onChange={handleChange}
                    error={!!server_error.product_Stock}
                    helperText={server_error.product_Stock?.[0]}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Pack Status</InputLabel>
                    <Select
                      name="product_isSale"
                      value={data.product_isSale}
                      onChange={handleChange}
                      label="Pack Status"
                    >
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Type comes first now */}
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Type</InputLabel>
                    <Select
                      name="type_name"
                      value={data.type_name || ''}
                      onChange={handleChange}
                      label="Type"
                    >
                      {types.map((t) => (
                        <MenuItem key={t.type_id} value={t.type_name}>
                          {t.type_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Category comes after Type */}
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Category</InputLabel>
                    <Select
                      name="category_Name"
                      value={data.category_Name || ''}
                      onChange={handleChange}
                      label="Category"
                      disabled={!filteredCategories.length}
                    >
                      {filteredCategories.map((cat) => (
                        <MenuItem key={cat.category_id} value={cat.category_Name}>
                          {cat.category_Name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Variation</InputLabel>
                    <Select
                      name="variation_name"
                      value={data.variation_name || ''}
                      onChange={handleChange}
                      label="Variation"
                      disabled={!filteredVariations.length}
                    >
                      {filteredVariations.map((variation) => (
                        <MenuItem key={variation.variation_id} value={variation.variation_name}>
                          {variation.variation_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Implant Company</InputLabel>
                    <Select
                      name="implant_Company"
                      value={data.implant_Company || ''}
                      onChange={handleChange}
                      label="Implant Company"
                    >
                      {companies.map((comp) => (
                        <MenuItem key={comp.company_id} value={comp.company_name}>
                          {comp.company_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Implant Connection</InputLabel>
                    <Select
                      name="brand_Name"
                      value={data.brand_Name || ''}
                      onChange={handleChange}
                      label="Brand"
                      disabled={!filteredBrands.length}
                    >
                      {filteredBrands.map((brand) => (
                        <MenuItem key={brand.brand_id} value={brand.brand_name}>
                          {brand.brand_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    size="large"
                    disabled={isLoading}
                    startIcon={isLoading ? <CircularProgress size={20} /> : null}
                    sx={{ mt: 2 }}
                  >
                    {isLoading ? 'Adding Product...' : 'Add Product'}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>

        {/* Status Alerts */}
        <Box sx={{ mt: 2 }}>
          {Object.entries(server_error).map(([key, value]) => (
            key.startsWith('image') && (
              <Alert key={key} severity="error" sx={{ mb: 1 }}>
                {`${key}: ${value[0]}`}
              </Alert>
            )
          ))}
          {success && (
            <Alert severity="success">
              Product added successfully. Redirecting...
            </Alert>
          )}
        </Box>
      </Paper>
    </Box>
  );
}

export default NewProduct;